import React, { useState } from "react";
import { useForm } from "react-hook-form";
import tvImage from "../../../assets/images/tataplay-tv-image.png";
import logo from "../../../assets/images/logo-updated.png";
import bottomshape from "../../../assets/images/tataplay-bottom.png";
import { BsEyeSlash, BsEyeSlashFill } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Captcha from "../Captcha/Captcha";
import BasicModal from "../../core/BaseComponents/Modal";
import Axios from "axios";

const CreatePassword = () => {
  const navigate = useNavigate();
  const search = useLocation().search;
  const key = new URLSearchParams(search).get("key");
  const token = new URLSearchParams(search).get("token");

  const [toggle, setToggleEye] = useState(true);
  const [confirmToggle, setConfirmToggle] = useState(true);
  const [apiError, setApiError] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [apiSuccessPopupOpen, setApiSuccessPopupOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    mode: 'onChange'
  });

  const onSubmit = (data) => {
    const requestHeaders = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    };

    Axios.put(
      `${process.env.REACT_APP_BASE_URL}/user/create-password`,
      { ...data, key: key },
      requestHeaders
    )
      .then(function (response) {
        setApiResponse(response?.data?.message);
        setApiError("");
        setApiSuccessPopupOpen(true);
      })
      .catch(function (error) {
        console.warn(error);
        setApiResponse("");
        setApiError(error.response?.data?.errors);
      });
  };

  const newPasswordEye = () => {
    setToggleEye(!toggle);
  };

  const newConfirmPasswordEye = () => {
    setConfirmToggle(!confirmToggle);
  };

  const popupCloseHandler = () => {
    setApiSuccessPopupOpen(false);
    navigate("/login");
  };

  return (
    <div className="login-container row">
      <div className="left-panel col-6">
        <div className="left-panel-tv-logo">
          <img src={tvImage} alt="left pannel setup box" />
        </div>
        <div className="left-panel-logo">
          <img src={logo} alt="login logo" />
        </div>
        <div className="left-panel-shape">
          <img src={bottomshape} alt="login bottom shape" />
        </div>
      </div>

      <div className="right-panel col-6">
        <div className="form-wrapper">
          <h2>Reset Account Password</h2>
          <p className="login-title">
            Your new password must be different from <br /> previous used
            passwords.
          </p>
          <p className="login-error">{apiError}</p>
          <p className="login-success">{apiResponse}</p>
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="form-group col-12 position-relative">
                <label htmlFor="password">New Password</label>
                {!toggle ? (
                  <BsEyeSlashFill
                    className="on-off-eye cursor-pointer"
                    onClick={newPasswordEye}
                  />
                ) : (
                  <BsEyeSlash
                    onClick={newPasswordEye}
                    className="on-off-eye cursor-pointer"
                  />
                )}
                <input
                  id="password"
                  type={toggle ? "password" : "text"}
                  className="form-control"
                  placeholder="Enter password"
                  {...register("password", {
                    required: "Please Enter New Password",
                    pattern: {
                      value: /^([a-zA-Z0-9-&@#$!])*$/,
                      message: "Password can only contain alphanumeric characters and @, #, $, -, or !",
                    },
                    minLength: {
                      value: 4,
                      message: "Password must be at least 4 characters long",
                    },
                  })}
                />
                {errors.password && (
                  <small className="error">{errors.password.message}</small>
                )}
              </div>
              <div className="form-group col-12 position-relative">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                {!confirmToggle ? (
                  <BsEyeSlashFill
                    className="on-off-eye cursor-pointer"
                    onClick={newConfirmPasswordEye}
                  />
                ) : (
                  <BsEyeSlash
                    onClick={newConfirmPasswordEye}
                    className="on-off-eye cursor-pointer"
                  />
                )}
                <input
                  id="confirmPassword"
                  type={confirmToggle ? "password" : "text"}
                  className="form-control"
                  placeholder="Enter Confirm password"
                  {...register("confirmPassword", {
                    required: "Please Enter Confirm Password",
                    pattern: {
                      value: /^([a-zA-Z0-9-&@#$!])*$/,
                      message: "Password can only contain alphanumeric characters and @, #, $, -, or !",
                    },
                    minLength: {
                      value: 4,
                      message: "Password must be at least 4 characters long",
                    },
                    validate: (value) =>
                      value === watch("password") || "Password and confirm password not matched",
                  })}
                />
                {errors.confirmPassword && (
                  <small className="error">
                    {errors.confirmPassword.message}
                  </small>
                )}
              </div>
              <div className="form-group col-12">
                <label htmlFor="captchaText">Captcha Code</label>
                <input
                  id="captchaText"
                  className="form-control"
                  placeholder="Enter Captcha Code"
                  {...register("captchaText", {
                    required: "Please Enter Captcha Code",
                  })}
                />
                {errors.captchaText && (
                  <small className="error">{errors.captchaText.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <Captcha />
              </div>
            </div>
            <div className=" col-7 mx-auto">
              <button type="submit" className="login-btn">
                Create New Password
              </button>
            </div>
          </form>
        </div>
      </div>
      <BasicModal
        popupOpen={apiSuccessPopupOpen}
        bodyMessage={apiResponse}
        logo={"/Images/approve-qc.png"}
        footer={{
          secondaryButton: {
            action: popupCloseHandler,
            buttonName: "OK",
          },
        }}
      />
    </div>
  );
};

export default CreatePassword;